import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title, children }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title

  return (
    <>
      <title>{title} | Centrum Terapeutyczne SANARE</title>
      <meta name="description" content={metaDescription} />
      <meta name="image" content={"/og-image.jpg"} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={'Centrum Terapeutyczne SANARE'} />
      <meta name="twitter:url" content={'Centrum Terapeutyczne SANARE'} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={"/og-image.jpg"} />
      <meta name="twitter:creator" content={"Sanare"} />
      <link rel="icon"
            href="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='0.9em' font-size='90'>👤</text></svg>" />
      {children}
    </>
  )
}

// SEO.defaultProps = {
//   lang: `pl`,
//   meta: [],
//   description: ``
// }
//
// SEO.propTypes = {
//   description: PropTypes.string,
//   lang: PropTypes.string,
//   meta: PropTypes.arrayOf(PropTypes.object),
//   title: PropTypes.string.isRequired
// }

export default SEO
